import {
  CustomerDetailsRow,
  CustomerDetailsLabel,
  CustomerDetailsInputWrapper,
  CustomerDetailsInputField,
} from './CustomerDetailsInput.styles';

const CustomerDetailsInput = (props) => {
  const { name, label, placeholder, onInputChange, disabled = false } = props;

  return (
    <CustomerDetailsRow>
      <CustomerDetailsLabel htmlFor={name}>{label}</CustomerDetailsLabel>
      <CustomerDetailsInputWrapper>
        <CustomerDetailsInputField
          id={name}
          name={name}
          placeholder={placeholder}
          onChange={onInputChange}
          disabled={disabled}
          data-testid={name}
        />
      </CustomerDetailsInputWrapper>
    </CustomerDetailsRow>
  );
};

export default CustomerDetailsInput;
